export const UI_MAP_READY = 'mapReady';
export const UI_MAP_LOADED = 'mapLoaded';
export const STOP_VIEW_API = 'stopViewApi';
export const START_VIEW_API = 'startViewApi';
export const UI_MAP_CLICKED = 'ui:map-clicked';
export const UI_INNER_MAP_READY = 'ui:mapReady';
export const UI_STEP_SELECTED = 'ui:step_selected';
export const MAP_OBJECT_HOVERED = 'map:objectHovered';
export const MAP_SHOW_PATH_STEPS = 'map:showPathSteps';
export const MAP_OBJECT_SELECTED = 'map:objectSelected';
export const UI_ON_CAMERA_UPDATE = 'ui:on_camera_update';
export const UI_MAP_LOADING_PROGRESS = 'ui:mapLoadingProgress';
export const UI_STEP_BY_STEP_DIRECTIONS = 'ui:step_by_step_directions';

export const GUIDE_CREATION_ERROR = 'ui:path_directions_error';
